module.exports = __webpack_public_path__ + "static/media/flight.e3734170.png";